import React, { useState, useEffect } from "react";
import "./ShopByCategorySlider.css";
import Icons from "../../../Config/Images";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  getProductCategoryByCategoryNameAPI,
  getProductCategoryDetailsAPI,
} from "../../../Store/Action/productCategory";
import CustomLoader from "../CustomComponents/CustomLoader/CustomLoader";

// const categories = [
//   { name: "Necklace", image: Icons.necklaceCategoryImage },
//   { name: "Rings", image: Icons.ringsCategoryImage },
//   { name: "Bracelet", image: Icons.braceletCategoryImage },
//   { name: "Earringssssssssssssssssssssssss", image: Icons.necklaceCategoryImage },
//   { name: "Bangles", image: Icons.ringsCategoryImage },
//   { name: "Chains", image: Icons.braceletCategoryImage },
//   { name: "Necklace", image: Icons.necklaceCategoryImage },
//   { name: "Rings", image: Icons.ringsCategoryImage },
//   { name: "Bracelet", image: Icons.braceletCategoryImage },
//   { name: "Earrings", image: Icons.necklaceCategoryImage },
//   { name: "Bangles", image: Icons.ringsCategoryImage },
//   { name: "Chains", image: Icons.braceletCategoryImage },
// ];

const itemsPerPage = 8;

const ShopByCategorySlider = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      getProductCategoryDetailsAPI({}, (result) => {
        setCategories(result?.data);
        setIsLoading(false);
      })
    );
  }, []);
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [categories, setCategories] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) => Math.max(prevIndex - 1, 0));
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      Math.min(prevIndex + 1, categories.length - itemsPerPage)
    );
  };

  useEffect(() => {
    dispatch(
      getProductCategoryDetailsAPI({}, (result) => {
        // setCategories(result?.data);
      })
    );
  }, [dispatch]);

  // Handle window resize to update window width
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const displayedCategories =
    windowWidth > 768
      ? categories.slice(currentIndex, currentIndex + itemsPerPage)
      : categories; // Show all categories below 768px

  const handleIndividualCategory = async (category) => {
    // setIsLoading(true);
    try {
      await dispatch(
        getProductCategoryByCategoryNameAPI(
          category?.product_category_name,
          (result) => {
            const fetchedSubCategories = result?.data[0]?.product_sub_category;
            navigate("/sub-categories", {
              state: { subCategories: fetchedSubCategories },
            });
          }
        )
      );
    } catch (error) {
      console.log("Error fetching subcategories:", error);
    } finally {
      // setIsLoading(false);
    }
  };
  return (
    <div className="shopByCategorySlider">
      <div className="upperHeader">
        <h3>Shop by Category</h3>
      </div>

      <div className="lowerContent-shopByCategorySlider">
        {/* Hide arrows below 768px */}
        {windowWidth > 768 && (
          <div
            className={`arrow-c leftArrow ${
              currentIndex === 0 ? "disabled" : ""
            }`}
            onClick={handlePrevClick}
          >
            <img src={Icons.leftSliderArrowIcon} alt="left arrow" />
          </div>
        )}

        <div className="categorySlider">
          {isLoading ? (
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          ) : (
            displayedCategories?.map((category, index) => (
              <div key={index} className="categoryImage">
                <img
                  src={
                    category.images?.[0]?.image
                      ? category.images?.[0]?.image
                      : Icons?.default_image
                  }
                  alt={category.name}
                  onClick={() => handleIndividualCategory(category)}
                />
                <p onClick={() => handleIndividualCategory(category)}>
                  {category.product_category_name}
                </p>
              </div>
            ))
          )}
        </div>

        {/* Hide arrows below 768px */}
        {windowWidth > 768 && (
          <div
            className={`arrow-c rightArrow ${
              currentIndex + itemsPerPage >= categories.length ? "disabled" : ""
            }`}
            onClick={handleNextClick}
          >
            <img src={Icons.rightSliderArrowIcon} alt="right arrow" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ShopByCategorySlider;
